<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            نظام الإحالة
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            آليات الإحالة بين المرافق وفاعليتها
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-services')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">مرافق لديها نظام إحالة رسمي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">62%</div>
          <div class="kpi-label">إحالة غير رسمية فقط</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">45 دق</div>
          <div class="kpi-label">متوسط وقت الإحالة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مرافق استقبال رئيسية</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">حالة نظام الإحالة</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>نظام إحالة رسمي؟</th>
            <th>بروتوكول مكتوب؟</th>
            <th>وسيلة النقل</th>
            <th>المرفق المستقبِل الرئيسي</th>
            <th>تسجيل الإحالات؟</th>
            <th>متوسط وقت الاستجابة</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.referralSystem)"
                size="small"
                variant="flat"
                >{{ item.referralSystem }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.protocol)"
                size="small"
                variant="flat"
                >{{ item.protocol }}</v-chip
              >
            </td>
            <td>{{ item.transport }}</td>
            <td>{{ item.receiver }}</td>
            <td>
              <v-chip
                :color="chipColor(item.registration)"
                size="small"
                variant="flat"
                >{{ item.registration }}</v-chip
              >
            </td>
            <td>{{ item.responseTime }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    referralSystem: "كامل",
    protocol: "كامل",
    transport: "سيارة إسعاف",
    receiver: "مستشفى النصر",
    registration: "كامل",
    responseTime: "30 دقيقة",
  },
  {
    name: "مستشفى الأمراض النفسية",
    referralSystem: "جزئي",
    protocol: "لا يوجد",
    transport: "سيارة خاصة",
    receiver: "مستشفى الصداقة",
    registration: "جزئي",
    responseTime: "45 دقيقة",
  },
  {
    name: "مجمع الشيخ عثمان",
    referralSystem: "جزئي",
    protocol: "جزئي",
    transport: "سيارة إسعاف",
    receiver: "مستشفى الصداقة",
    registration: "جزئي",
    responseTime: "20 دقيقة",
  },
  {
    name: "مركز كود العثماني",
    referralSystem: "كامل",
    protocol: "كامل",
    transport: "سيارة خاصة",
    receiver: "مجمع الشيخ عثمان",
    registration: "كامل",
    responseTime: "15 دقيقة",
  },
  {
    name: "مركز الممدارة",
    referralSystem: "كامل",
    protocol: "كامل",
    transport: "سيارة خاصة",
    receiver: "مجمع الشيخ عثمان",
    registration: "كامل",
    responseTime: "10 دقيقة",
  },
  {
    name: "مركز المحاريق",
    referralSystem: "لا يوجد",
    protocol: "لا يوجد",
    transport: "سيارة خاصة",
    receiver: "مستشفى الصداقة",
    registration: "لا يوجد",
    responseTime: "40 دقيقة",
  },
  {
    name: "مركز عبد القوي",
    referralSystem: "جزئي",
    protocol: "لا يوجد",
    transport: "سيارة خاصة",
    receiver: "مجمع الشيخ عثمان",
    registration: "جزئي",
    responseTime: "25 دقيقة",
  },
  {
    name: "مركز ماري ستبوس",
    referralSystem: "لا يوجد",
    protocol: "لا يوجد",
    transport: "سيارة خاصة",
    receiver: "مستشفى الصداقة",
    registration: "لا يوجد",
    responseTime: "30 دقيقة",
  },
  {
    name: "جمعية حقوق الطفل",
    referralSystem: "لا يوجد",
    protocol: "لا يوجد",
    transport: "سيارة خاصة",
    receiver: "مجمع الشيخ عثمان",
    registration: "لا يوجد",
    responseTime: "20 دقيقة",
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.primary {
  background: #f0f1f2;
  color: #4a4f55;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
